import styled, { css } from 'styled-components';
import { colors, fontFamily } from 'components/styles/_variables';

export const Wrapper = styled.div`
  ${({ row }) =>
    row &&
    css`
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    `}
`;

export const StyledLabel = styled.label`
  font-family: ${fontFamily.primary};
  font-size: 16px;
  font-weight: 600;
  //line-height: 2.13;
  letter-spacing: -0.27px;
  color: #636262;
  display: flex;
  align-items: baseline;
  margin-bottom: 16px;
  position: relative;
  cursor: pointer;
  ${({ selected }) =>
    !selected &&
    css`
      opacity: 0.4;
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.6;
      cursor: not-allowed;
    `}
`;

export const ItemDescription = styled.p`
  font-family: ${fontFamily.primary};
  font-size: 14px;
  font-weight: normal;
  color: #636262;
  margin-top: 5px;
`;

export const SuffixWrapper = styled.div`
  position: absolute;
  left: 200px;
  top: -17px;
`;

export const InfoWrapper = styled.div`
  margin-left: 10px;
`;

export const Mark = styled.span`
  display: inline-block;
  position: relative;
  border: 1px solid #ff7828;
  min-width: 11px;
  min-height: 11px;
  left: 0;
  border-radius: 50%;
  //margin-right: 5px;
  vertical-align: middle;
  &::after {
    content: '';
    display: block;
    width: 0;
    height: 0;
    border-radius: 50%;
    background-color: #ff7828;
    opacity: 0;
    left: 50%;
    top: 50%;
    position: absolute;
    transition: all 110ms;
  }
`;

export const RadioInput = styled.input`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  &:checked + ${Mark} {
    &::after {
      width: 5px;
      height: 5px;
      opacity: 1;
      left: 2px;
      top: 2px;
    }
  }
`;
